<template>
    <section>
        <v-layout row>
            <v-flex style="width: 50%; margin: 10px;font-size: 16px;font-weight: bold;">Course Videos :</v-flex>
            <v-flex style="width: 50%; margin: 10px;font-size: 16px;font-weight: bold;">Course Images :</v-flex>
        </v-layout>
        <v-layout row>
        <v-data-table style="width: 50%; margin: 10px;" 
                      :headers="headers_preview" 
                      :items="GetCourseList" 
                      item-key="Course_Title" class="elevation-1">
            <template v-slot:headers="props">
                <tr>
                    <th v-for="header in props.headers" :key="header.text">
                        {{ header.text }}
                    </th>
                </tr>
            </template>
            <template v-slot:items="props">
                <tr>
                    <td class="text-xs-center">{{ props.item.Course_Title }}</td>
                    <td class="text-xs-center">
                        <video :id="'video_table_'+props.item._id" loop controls :src="props.item.Course_Preview_Video" style="width: 200px;height: 110px;" ></video>
                    </td>
                    <td class="text-xs-center" style="padding: 18px;">
                        <video :id="'video_table_course'+props.item._id" loop controls :src="props.item.Course_Video" style="width: 200px;height: 110px;" ></video>
                    </td>
                </tr>
            </template>
        </v-data-table>
        
        <v-data-table style="width: 50%; margin: 10px;" :headers="headers_course" :items="GetCourseList" item-key="Course_Title" class="elevation-1">
            <template v-slot:headers="props">
                <tr>
                    <th v-for="header in props.headers" :key="header.text">
                        {{ header.text }}
                    </th>
                </tr>
            </template>
            <template v-slot:items="props">
                <tr>
                    <td class="text-xs-center">{{ props.item.Course_Title }}</td>
                    <td class="text-xs-center" style="padding: 18px;">
                        <img :id="'img_table_'+props.item._id" :src="props.item.Course_Image" style="width: 200px;height: 110px;" />
                    </td>
                     <td class="text-xs-center" style="padding: 18px;">
                        <img :id="'img_table_'+props.item._id" :src="props.item.Course_Banner" style="width: 200px;height: 110px;" />
                    </td>
                </tr>
            </template>
        </v-data-table>
        </v-layout>
        <app-update-preview ref="UpdatePreview" :dialog="UpdatePreview" @close='CloseDialog'></app-update-preview>
        <app-update-course ref="UpdateCourse" :dialog="UpdateCourse" @close='CloseDialog'></app-update-course>
    </section>
</template>
<script>

import appUpdatePreview  from '../dialogs/AddCourseImage'
import appUpdateCourse     from '../dialogs/AddCourseVideo'

export default {
    components: {

        appUpdatePreview,
        appUpdateCourse

    },
    data(){

        return {

            headers_preview  : [ { text: 'Course Title',value: 'Course_Title' },
                                 { text: 'Course Preview Video', value: 'Course_Preview_Video' } ,
                                 { text: 'Course Video', value: 'Course_Video' }],
            headers_course   : [ { text: 'Course Title',value: 'Course_Title'  },
                                 { text: 'Course Image', value: 'Course_Image' },
                                 { text: 'Course Banner', value: 'Course_Banner' }],
            UpdatePreview   : false,
            UpdateCourse    : false
        }
    },
    computed:{
        GetCourseList(){

            return this.$store.getters.GetCourseDetailsList
        }
    },
    methods:{
      OpenUpdateCourseModal(Course){

          this.UpdateCourse = true
          this.$refs.UpdateCourse.GetCourseInfo(Course)
      },
      OpenUpdatePreviewModal(Course){

          this.UpdatePreview  = true
          this.$refs.UpdatePreview.GetPreviewInfo(Course)
      },
      CloseDialog(){

          this.UpdateCourse = false
          this.UpdatePreview    = false
      }
    },
    mounted(){

        this.$http.post(`${this.$store.getters.GetProductionUrl}/course/getallcoursedetailslist`)
                    .then(response =>{
                        
                        this.$store.commit('SetCourseDetailList',response["data"]["response"])
                    })
                    .catch(err =>{

                        this.$eventHub.$emit('SNACK_BAR',{ "Show" : true ,"Text": "Error While Fetching Data","Color":"red","Close": false });
                    })
    }
}
</script>
<style scoped>

</style>


